module.exports = __webpack_public_path__ + "../../static/img/sloth2.332478c4.png";